import React from 'react'
import { connect } from 'react-redux'

import Link from './Link'
import Icon from './Icon'
import Logo from './Logo'
import Button from './Button'
import SocialFollowButtons from './SocialFollowButtons'
import NewsletterSignupModal from './NewsletterSignupModal'

import { showModal } from '../../reducers/modal'

import { JOBS_URL, DOCS_URL, TERMS_CONDITIONS_URL } from '../../config'

const CURRENT_YEAR = new Date().getFullYear()

const LINKS = [
  {
    label: 'Home',
    href: '/'
  },
  {
    label: 'Makers',
    href: 'https://makers.snips.ai',
    target: '_blank'
  },
  {
    label: 'About us',
    href: '/about/'
  },
  {
    label: 'Press',
    href: '/press/'
  },
  {
    label: 'Terms & Conditions',
    href: TERMS_CONDITIONS_URL,
    target: '_blank'
  },
  {
    label: 'Blog',
    href: 'https://medium.com/snips-ai',
    target: '_blank'
  },
  {
    label: 'Jobs',
    href: JOBS_URL,
    target: '_blank'
  },
  {
    label: 'Contact Us',
    href: '/contact'
  },
  {
    label: 'Documentation',
    href: DOCS_URL,
    target: '_blank'
  }
]

function FooterLinks ({ links }) {
  return (
    <ul className='footer__links__list mb4'>
      {links.map(
        ({ label, href, icon, altText, forceAnchorElement, target }, idx) => (
          <li key={idx} className='footer__links__list-item'>
            <Link
              href={href}
              forceAnchorElement={forceAnchorElement}
              target={target}
            >
              {label}
            </Link>
          </li>
        )
      )}
    </ul>
  )
}

function FooterMain () {
  return (
    <div className='footer-main footer-main__content'>
      <div className='footer__address mb3'>
        <ul className='footer__address__list'>
          <li className='footer__address__list-item-outer mb2'>
            <div className='footer__address__list-item-inner dark-blue'>
              <div className='strong'>New York</div>
              <div className='small'>
                33 Greene Street<br />
                New York 10013<br />
                United States
              </div>
            </div>
          </li>
          <li className='footer__address__list-item-outer mb2'>
            <div className='footer__address__list-item-inner dark-blue'>
              <div className='strong'>Paris</div>
              <div className='small'>
                18 rue Saint Marc<br />
                75002 Paris<br />
                France
              </div>
            </div>
          </li>
        </ul>
      </div>
      <FooterLinks links={LINKS} />
    </div>
  )
}

function FooterExtra ({ showModal }) {
  return (
    <div className='footer__extra flex flex-column'>
      <div className='footer__extra-group mb3'>
        <div className='small footer__extra-follow-label mb2'>Follow us</div>
        <SocialFollowButtons />
      </div>
      <div className='footer__extra-group footer__newsletter self-center mb3'>
        <Button
          className='button footer__newsletter-button flex justify-between'
          onClick={() => showModal(<NewsletterSignupModal />)}
        >
          <span className='mr2'>Newsletter Signup</span>
          <Icon icon='carousel-arrow-right' />
        </Button>
      </div>
    </div>
  )
}

const ConnectedFooterExtra = connect(null, { showModal })(FooterExtra)

function Footer () {
  return (
    <footer
      className='footer bg-light-grey overflow-hidden maxw-xxlarge mx-auto pt3'
      id='footer'
    >
      {/* NOTE: the id here is used by Menu */}
      <FooterMain />
      <ConnectedFooterExtra />
      <div className='footer__brand mb3'>
        <a className='footer-main__logo' href='/'>
          <Logo />
        </a>
        <small>&copy;{CURRENT_YEAR} Snips</small>
      </div>
    </footer>
  )
}

export default connect(null)(Footer)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Footer.js